import {
  Link,
  Text,
} from '@chakra-ui/react';
import {
  useBridgesCount,
} from '@src/modules/performance/context/reports-api-hooks';

import Chart from 'react-apexcharts';
import GroupedRegionMessage from '@src/modules/performance/components/GroupedRegionMessage';
import { CHART_COLOURS } from '@src/modules/performance/shared/constants';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Bridges',
  content: [
    {
      title: 'No. bridges',
      description:
  <Text fontSize="inherit" mb={2}>
    The total number of bridges, the number of bridges where there is only a single lane and number of bridges made from timber.
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, physical statistics - bridges</Link>
  </Text>,
    },
  ],
};

function NetworkPhysicalCharacteristicsBridges() {
  const { data: bridgesCount, isLoading } = useBridgesCount();
  const bridgesCountYears = [...new Set(bridgesCount?.map((x) => x.Year))];
  const bridgesCountSeries = [
    {
      name: 'Total',
      type: 'line',
      data: bridgesCount?.map((item) => ({
        x: item.Year,
        y: item.AllBridgesCount,
      })),
      color: CHART_COLOURS.blue,
    },
    {
      name: 'Timber',
      type: 'line',
      data: bridgesCount?.map((item) => ({
        x: item.Year,
        y: item.TimberCount,
      })),
      color: CHART_COLOURS.orangered,
    },
    {
      name: 'Single Lane',
      type: 'line',
      data: bridgesCount?.map((item) => ({
        x: item.Year,
        y: item.SingleLaneCount,
      })),
      color: CHART_COLOURS.grey,
    },
  ];

  return (
    <ReportSection
      title="Bridges"
      isLoading={isLoading || !bridgesCount}
      informationSource={informationSource}
      lockYear={bridgesCount?.[0]?.LockYear || null}
    >
      <Chart
        options={
          {
            title: {
              text: 'No. of bridges',
            },
            chart: {
              animations: {
                enabled: false,
              },
            },
            xaxis: {
              categories: bridgesCountYears,
              labels: {
                offsetY: 5,
                rotate: -45,
                rotateAlways: true,
              },
            },
            yaxis: [
              {
                forceNiceScale: false,
                labels: {
                  formatter(y) {
                    return `${y.toFixed(0)}`;
                  },
                },
              },
            ],
            grid: {
              padding: {
                left: 20,
              },
            },
            dataLabels: {
              enabled: false,
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: (val) => `${val.toFixed(0)}`,
              },
            },
          }
        }
        series={bridgesCountSeries}
        type="line"
        width="100%"
        height="280"
      />
      <GroupedRegionMessage
        rcaIds={[1014, 1015, 1016]}
        roadTypes={['shlr', 'sh']}
        messagePrefix="Combined results for"
        messageSuffix="for State Highways and All Roads"
      />
    </ReportSection>
  );
}

export default NetworkPhysicalCharacteristicsBridges;
